// OpenAI-compatible client for AMHAS LLM service
class OpenAIClient {
    constructor(baseURL = '/api/ai') {
        this.baseURL = baseURL;
    }

    async chatCompletion(messages, options = {}) {
        try {
            console.log('Sending request to:', `${this.baseURL}/v1/chat/completions`);
            console.log('Messages:', messages);

            const response = await fetch(`${this.baseURL}/v1/chat/completions`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    messages,
                    model: options.model || 'gpt-3.5-turbo',
                    temperature: options.temperature || 0.7,
                    max_tokens: options.max_tokens || 1000,
                    ...options
                })
            });

            console.log('Response status:', response.status);
            console.log('Response headers:', response.headers);

            if (!response.ok) {
                const errorText = await response.text();
                console.error('Error response:', errorText);
                throw new Error(`HTTP error! status: ${response.status}, body: ${errorText}`);
            }

            const data = await response.json();
            console.log('Response data:', data);
            return data;
        } catch (error) {
            console.error('Error calling OpenAI API:', error);
            throw error;
        }
    }

    async healthCheck() {
        try {
            const response = await fetch(`${this.baseURL}/`);
            return response.ok;
        } catch (error) {
            console.error('Health check failed:', error);
            return false;
        }
    }

    // Convenience method for simple chat
    async chat(message, options = {}) {
        const messages = [
            {
                role: 'user',
                content: message
            }
        ];

        const response = await this.chatCompletion(messages, options);
        return response.choices[0]?.message?.content || '';
    }

    // Method for healthcare-specific queries
    async askHealthcareQuestion(question, context = {}) {
        const systemPrompt = `You are a helpful healthcare assistant for AMHAS (African Medical Health Access System). 
        You provide information about child healthcare, school-based health programs, and AMHAS services in The Gambia.
        
        Context: ${JSON.stringify(context)}
        
        Please provide accurate, helpful information while being mindful of medical disclaimers.`;

        const messages = [
            {
                role: 'system',
                content: systemPrompt
            },
            {
                role: 'user',
                content: question
            }
        ];

        return await this.chatCompletion(messages, {
            temperature: 0.3, // Lower temperature for more consistent healthcare responses
            max_tokens: 500
        });
    }

    // Method for school-related queries
    async askSchoolQuestion(question, schoolData = {}) {
        const systemPrompt = `You are a helpful assistant for AMHAS school directory. 
        You help users find information about schools in The Gambia and their AMHAS healthcare participation.
        
        School Data: ${JSON.stringify(schoolData)}
        
        Provide helpful information about schools, enrollment, and AMHAS services.`;

        const messages = [
            {
                role: 'system',
                content: systemPrompt
            },
            {
                role: 'user',
                content: question
            }
        ];

        return await this.chatCompletion(messages, {
            temperature: 0.4,
            max_tokens: 400
        });
    }
}

// Create singleton instance
const openaiClient = new OpenAIClient();

export default openaiClient;
